<template lang="pug">
  el-select(v-model='internalValue' filterable @change='onChange')
    el-option(v-for='currency in currencyList' :key='currency.code' :value='currency.code')
     | {{ currency.name }} ({{ currency.symbol_native }})

</template>

<script>
import { availableCurrencies } from "@/shared/utils/currencies";

export default {
  props: ["value", "initialValue"],
  watch: {
    value(newVal) {
      this.internalValue = newVal;
    }
  },
  data() {
    return {
      internalValue: this.value,
      currencyList: availableCurrencies
    };
  },
  methods: {
    onChange(value) {
      this.$emit("input", value);
    }
  },
  mounted() {
    if (this.initialValue && !this.value) {
      this.internalValue = this.initialValue;
    }
  }
};
</script>

<style scoped lang="scss"></style>
